import React, { useEffect, useContext, useState } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory, Link } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import CarEspaciosParticipantes from "../element/CarEspaciosParticipantes";
import Menu from "./Menu";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import Horas from "../hooks/HorasEspaciosDeportivos";
// import SetBitacora from "../helper/SetBitacora";
import loadMenu from "../js/main";
import Footer from "./Footer";
// Estilos
import "../css/styleEspaciosDeportivos.css";

const CanchaVoleibol = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  if (datos) {
    let cred = JSON.parse(datos);
    dataUser.token = cred.token;
    dataUser.nombre = cred.nombre;
    dataUser.carnet = cred.carnet;
    dataUser.correo = cred.correo;

    // SetBitacora.set(cred.carnet, 'Canchas', cred.token);
  } else {
    history.push("/");
  }

  const [fechaHoy, setFechaHoy] = useState(0);
  const [fechaDate, setFechaDate] = useState(0);
  const [horaInico, setHoraInicio] = useState();
  const [horaFin, setHoraFin] = useState();
  const [horaInicoIndice, setHoraInicioIndice] = useState(0);
  const [horaFinIndice, setHoraFinIndice] = useState(0);
  const [alertValidacion, setAlertValidacion] = useState(0);
  const [horaActual, setHoraActual] = useState(0);
  const [participantes, setParticipantes] = useState([]);
  const [pasantiaID, setPasantiaID] = useState();
  const [reservados, setReservados] = useState({0:0});
  const [libres, setLibres] = useState({0:0});
  const [alertValidacionReservas, setAlertValidacionReservas] = useState(0);

  const horaActualPresente = (horaMinimaSeleccionar) => {
    let fechaHoraActual = new Date(Date.now());
    let hms = +horaMinimaSeleccionar.substr(0, 2);
    let minutosSeleccionado = horaMinimaSeleccionar.substr(3, 2);
    let horaSistemaPresente = fechaHoraActual.getHours();
    let minutosSistemaPresente = fechaHoraActual.getMinutes();
    if (+comparandoFechas()) {
      if (hms === horaSistemaPresente) {
        if (+minutosSeleccionado === 0) {
          if (minutosSistemaPresente < 30) {
            setHoraActual(0);
          } else {
            setHoraActual(1);
          }
        } else {
          setHoraActual(0);
        }
      } else if (hms > horaSistemaPresente) {
        setHoraActual(0);
      } else {
        setHoraActual(1);
      }
    } else {
      setHoraActual(0);
    }
  };

  const comparandoFechas = () => {
    let fechaActual = Horas.FechaActual();
    let presente = new Date(fechaActual);
    presente.setDate(presente.getDate() + 1);
    let fin = new Date(fechaDate);
    fin.setDate(fin.getDate() + 1);

    if (presente < fin) {
      return 0;
    } else {
      return 1;
    }
  };

  useEffect(() => {
    let fechaHoy = Horas.formatFecha(new Date(Date.now()));
    // fechaHoy = fechaHoy.replace(/\//g, "-"); //Quitando las plecas y poniendo guiones
    GetFetch.getDeportiosEspacios(fechaHoy, "Cancha multideporte").then(
      (data) => {
        let fechaHoraActual = new Date(Date.now());
        let horaSistemaPresente = fechaHoraActual.getHours();
        if (data.length > 0) {
          //Existen registro con la fecha presente
          //Leer horas disponibles
          Horas.HorasLibres(
            "selectHoraInicio",
            data[0].spacios_libres,
            horaSistemaPresente
          );
          Horas.HorasLibres(
            "selectHoraFin",
            data[0].spacios_libres,
            horaSistemaPresente
          );
          setPasantiaID(data[0]._id);
          setReservados(data[0].spacios_reservados);
          setLibres(data[0].spacios_libres);
        } else {
          //Poner todas las horas disponibles no hay ristro con la fecha presente
          Horas.HorasLibres(
            "selectHoraInicio",
            Horas.horas,
            horaSistemaPresente
          );
          Horas.HorasLibres("selectHoraFin", Horas.horas, horaSistemaPresente);
        }
      }
    );
    setFechaHoy(Horas.formatFecha(Horas.FechaActual()));
    setFechaDate(Horas.FechaActual());
    loadMenu();
  }, []);

  let fechaMin = Horas.FechaActual();

  const fechaDateSet = (e) => {
    setFechaDate(e.target.value);
    setFechaHoy(Horas.formatFecha(e.target.value, 1));
    updateSelectHorasChangeDate(Horas.formatFecha(e.target.value, 1));
    setAlertValidacion(1);
  };

  const horaInicioSet = (e) => {
    setHoraInicio(Horas.horas[+e.target.value]);
    setHoraInicioIndice(+e.target.value);
    horaActualPresente(Horas.horas[+e.target.value]);
    Horas.resetFin();
  };


  const horaFinSet = (e) => {
    setHoraFin(Horas.horas[+e.target.value]);
    setHoraFinIndice(+e.target.value);
    validacionHoras(+e.target.value);
    validacionReservas(Horas.calculoHorasIntermedias(horaInicoIndice,+e.target.value));
  };

  let validacionReservas = (horasElegidas)=>{
    let horasNoDisponibles = [];
    horasElegidas.map((element)=>{
      if (reservados[element] !== undefined) {
        horasNoDisponibles.push(reservados[element]);        
      }
      return null;
    })

    if (horasNoDisponibles.length > 0) {
      setAlertValidacionReservas(horasNoDisponibles);
    }else{
      setAlertValidacionReservas(0);
    }
  }

  let validacionHoras = (fin) => {
    if (horaInicoIndice < fin) {
      setAlertValidacion(0);
    } else {
      setAlertValidacion(1);
    }
  };

  const updateSelectHorasChangeDate = (fecha) => {
    let fechaHoraActual = new Date(Date.now());
    let horaSistemaPresente = fechaHoraActual.getHours();
    let diaSistema = fechaHoraActual.getDate();
    let diaSeleccionado = fecha.substr(0, 2);
    if (+diaSeleccionado !== +diaSistema) {
      horaSistemaPresente = "08:00";
    }

    GetFetch.getDeportiosEspacios(fecha, "Cancha multideporte").then((data) => {
      if (data.length > 0) {
        //Existen registro con la fecha presente
        //Leer horas disponibles
        Horas.HorasLibres(
          "selectHoraInicio",
          data[0].spacios_libres,
          horaSistemaPresente
        );
        Horas.HorasLibres(
          "selectHoraFin",
          data[0].spacios_libres,
          horaSistemaPresente
        );
        setPasantiaID(data[0]._id);
        setReservados(data[0].spacios_reservados);
        setLibres(data[0].spacios_libres);
      } else {
        //Poner todas las horas disponibles no hay ristro con la fecha presente
        Horas.HorasLibres("selectHoraInicio", Horas.horas);
        Horas.HorasLibres("selectHoraFin", Horas.horas);
        setPasantiaID();
        setReservados({0:0});
        setLibres(Horas.horas);
      }
    });
  };

  const btnReservar = async (e) => {
    e.preventDefault();
    const data = new FormData();
    if (setPasantiaID) {
      data.append("_id", pasantiaID);
    }
    data.append("secret", "5ec4702eff406849a82818cb");
    data.append("espacio", "Cancha multideporte");
    data.append("fecha", fechaHoy);
    data.append("date", fechaDate);
    data.append("spacios_libres", JSON.stringify(libres));
    data.append("spacios_reservados", JSON.stringify(reservados));
    data.append("spacios_ocupados", JSON.stringify({ 0: 0 }));
    let reservas = [
      {
        responsable: dataUser.carnet,
        nombre: dataUser.nombre,
        correo: dataUser.correo,
        hora_inicio: horaInicoIndice,
        hora_fin: horaFinIndice,
        participantes,
        stado: "0",
        fecha_reserva: fechaHoy,
        espacio: 'voleibol'
      },
    ];
    data.append("reservas", JSON.stringify(reservas));

    await GetFetch.setDeportiosEspaciosReserva(data, dataUser.token).then(
      (datosSet) => {
        if (datosSet.success) {
          history.push("/canchas");
        } else {
          return 0;
        }
      }
    );
  };

 
  const getParticipante = async (e) => {
    let idCampoNombre = e.target.dataset.id;
    let correlativo   = e.target.dataset.correlativo;
    if (e.target.value.length === 8 && e.target.value !== dataUser.carnet) {
      let validarParticipante = participantes.find((elemento) => {
        let a = null;
        if (elemento.carnet === e.target.value) {
          a = elemento;
          return elemento;
        }
        return a;
      });
      if (validarParticipante) {
        document.getElementById(idCampoNombre).value = "Carnet ya ingresado !!!";
      } else {
        let data = await GetFetch.getDeportiosParticipante(
          e.target.value,
          dataUser.token
        );
     
        if (data.length > 0) {
          let nombreParticipante = data[0].nombres + " " + data[0].apellidos;
          let correoParticipante = data[0].correo_electronico;

          document.getElementById(idCampoNombre).value = nombreParticipante;

          participantesSet(
            data[0].usuario,
            nombreParticipante,
            correoParticipante
          );
      
          document.getElementById("deleleparticipante" + correlativo).setAttribute("data-carnet", data[0].usuario);
          document.getElementById("textcarnet" + correlativo).disabled = true;
        } else {
          document.getElementById(idCampoNombre).value = "Carnet no valido..";
        }
      }
    } else if (e.target.value.length === 0) {
      document.getElementById(idCampoNombre).value = "";
    }
  };

  const participantesMaximo = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const participantesSet = (carnet, nombre, correo) => {
    setParticipantes([...participantes, { carnet, nombre, correo }]);
  };

  const deleteParticipante = (e) => {
    let carnet = e.target.dataset.carnet;
    let correlativo   = e.target.dataset.correlativo;
    // let indiceBorrado = e.target.dataset.id.substr(-1);
    let newData = participantes.filter((elemento) => {
      let b = null;
      if (elemento.carnet !== carnet) {
        document.getElementById("textcarnet" + correlativo).value = "";
        document.getElementById("textcarnet" + correlativo).disabled = false;
        document.getElementById("participantecarnet" + correlativo).value =
          "";
          b = elemento;
        return elemento;
      }
      return b;
    });

    setParticipantes(newData);
  };

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Cancha de voleibol</h2>

        <div className="card mb-4">
          <div className="card-body">
            <div className="text-center mb-4">
              <span className="text-muted">Reservar para el</span>
              <span className="esen-reserva-dia">{fechaHoy}</span>
              <div className="mt-2">
                <span className="esen-chip esen-chip--info mr-2">
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                  Inicio: {horaInico ? horaInico : "--:--"}
                </span>
                <span className="esen-chip esen-chip--info">
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                  Fin: {horaFin ? horaFin : "--:--"}
                </span>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="fechaReserva">Cambiar fecha</label>
              <input
                id="fechaReserva"
                type="date"
                className="form-control"
                min={fechaMin}
                value={fechaDate}
                onChange={fechaDateSet}
              />
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <label htmlFor="selectHoraInicio">Hora de inicio</label>
                  <select
                    id="selectHoraInicio"
                    className="form-control"
                    onChange={horaInicioSet}
                  >
                    <option>Seleccionar hora</option>
                  </select>
                </div>
              </div>
              <div className="col">
                <div className="form-group">
                  <label htmlFor="selectHoraFin">Hora de fin</label>
                  <select
                    className="form-control"
                    id="selectHoraFin"
                    onChange={horaFinSet}
                  >
                    <option>Seleccionar hora</option>
                  </select>
                </div>
              </div>
            </div>

            {horaActual === 0 ? null : (
              <div className="alert alert-danger" role="alert">
                <i className="fa fa-bell-o mr-2" aria-hidden="true"></i>{" "}
                <b>Hora de inicio</b> seleccionada fuera de reserva.
              </div>
            )}
            {alertValidacion === 0 ? null : (
              <div className="alert alert-danger" role="alert">
                <i className="fa fa-bell-o mr-2" aria-hidden="true"></i>{" "}
                <b>Hora de finalización</b> debe ser mayor a la hora de inicio.
              </div>
            )}
            {alertValidacionReservas === 0 ? null : (
              <div className="alert alert-danger" role="alert">
                <i className="fa fa-bell-o mr-2" aria-hidden="true"></i>{" "}
                Las horas seleccionadas cubren franjas que ya están reservadas:{" "}
                {alertValidacionReservas.map((el, l) => {
                  return <b key={l}>{el} / </b>;
                })}
              </div>
            )}

            <h3 className="h5 mt-4 mb-2">Disponibilidad del día</h3>
            <p className="mb-2">
              <span className="esen-chip esen-chip--success mr-2">Disponible</span>
              <span className="esen-chip esen-chip--danger">Reservada</span>
            </p>
            <div className="esen-slot-grid mb-2">
              {Object.keys(Horas.horas).map((franja) => (
                <span
                  key={franja}
                  className={
                    reservados[franja] !== undefined
                      ? "esen-chip esen-chip--danger"
                      : "esen-chip esen-chip--success"
                  }
                >
                  {Horas.horas[franja]}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="card mb-4">
          <div className="card-body">
            <h3 className="h5 mb-2">Participantes</h3>
            <p className="text-muted">
              Ingresa el carnet de cada participante para validarlo.
            </p>
            {participantesMaximo.map((elemt) => {
              return (
                <CarEspaciosParticipantes
                  key={elemt}
                  indice={elemt}
                  getParticipante={getParticipante}
                  deleteParticipante={deleteParticipante}
                />
              );
            })}
            {alertValidacion === 0 && horaInicoIndice > 0 && horaFinIndice > 0 ? (
              <button
                type="button"
                className="btn btn-primary btn-block mt-3"
                onClick={btnReservar}
              >
                <i className="fa fa-check mr-2" aria-hidden="true"></i>
                Reservar
              </button>
            ) : null}
          </div>
        </div>

        <Link className="btn btn-outline-primary" to="/canchas">
          <i className="fa fa-arrow-left mr-2" aria-hidden="true"></i>
          Volver a espacios deportivos
        </Link>
      </div>
    </div>
  );
};

export default CanchaVoleibol;
